<template>
  <div class="row">
    <div class="col-3 px-2 text-center">
      <b-form-radio id="microWave" v-model="vModel" name="microWave" :value="PUNCHED_BOX_TYPES.MICRO_WAVE"></b-form-radio>
      <label for="microWave" class="d-block">
        <b-img src="@/assets/images/inputs/micro-wave.png" fluid alt="micro onda"></b-img>
        <small>{{ $t('props.boxTypes.microWave') }}</small>
      </label>
    </div>
    <div class="col-3 px-2 text-center">
      <b-form-radio id="lowWave" v-model="vModel" name="boxType" :value="PUNCHED_BOX_TYPES.LOW_WAVE"></b-form-radio>
      <label for="lowWave" class="d-block">
        <b-img src="@/assets/images/inputs/low-wave.png" fluid alt="onda bassa"></b-img>
        <small>{{ $t('props.boxTypes.lowWave') }}</small>
      </label>
    </div>
    <div class="col-3 px-2 text-center">
      <b-form-radio id="highWave" v-model="vModel" name="boxType" :value="PUNCHED_BOX_TYPES.HIGH_WAVE"></b-form-radio>
      <label for="highWave" class="d-block">
        <b-img src="@/assets/images/inputs/high-wave.png" fluid alt="tre onde"></b-img>
        <small>{{ $t('props.boxTypes.highWave') }}</small>
      </label>
    </div>
    <div class="col-3 px-2 text-center">
      <b-form-radio id="microTriple" v-model="vModel" name="boxType" :value="PUNCHED_BOX_TYPES.MICRO_TRIPLE"></b-form-radio>
      <label for="microTriple" class="d-block">
        <b-img src="@/assets/images/inputs/micro-triple.png" fluid alt="microtriplo"></b-img>
        <small>{{ $t('props.boxTypes.microTriple') }}</small>
      </label>
    </div>
  </div>
</template>
<script>
import { InputField } from './Input.mixin'
import { PUNCHED_BOX_TYPES } from '../../utils/products.enums'

export default {
  name: 'InputBoxTypePunched',
  extends: InputField,
  data () {
    return {
      PUNCHED_BOX_TYPES,
      vModel: this.value
    }
  },
  watch: {
    vModel (boxType) {
      this.$emit('input', boxType)
    }
  }
}
</script>
